export default "__VITE_ASSET__ZFp$QVZ4__"